/** `center` crops to the requested box from the middle, `smart` is the service's square crop. */
export type ImageCrop = 'none' | 'center' | 'smart';

/** `webp` re-encodes on the image service; `original` keeps the uploaded format. */
export const ImageFormat = { Webp: 'webp', Original: 'original' } as const;
export type ImageFormat = (typeof ImageFormat)[keyof typeof ImageFormat];

/** Sizes are CSS pixels; the URL builder scales them by the device pixel ratio. */
export interface ImageUrlOptions {
  /** Longest side. Ignored when `width` or `height` is set. */
  size?: number;
  width?: number;
  height?: number;
  crop?: ImageCrop;
  format?: ImageFormat;
  /** 1–100, JPEG only. */
  quality?: number;
  /** The untouched upload — for fullscreen viewing. Overrides every other option. */
  original?: boolean;
}
